<div class="progress" *ngIf="currentTimeStr && durationStr">
  <div class="progress__start">{{ currentTimeStr }}</div>
  <div
    class="progress-bar htv-selectable htv-force-direction htv-autofocus"
    tabindex="-1"
    (focus)="onFocus()"
    (blur)="onBlur()">
    <div class="progress-preview" [style.width.%]="previewPercent" [class.seeking]="previewChanged"></div>
    <div class="progress-fill" [style.width.%]="progress"></div>
    <div class="progress-thumb" [style.left.%]="previewPercent" [class.seeking]="previewChanged"></div>
  </div>
  <div class="progress__end">{{ durationStr }}</div>
</div>
